import { render, staticRenderFns } from "./StatementsPeriod.vue?vue&type=template&id=20b6c422"
import script from "./StatementsPeriod.vue?vue&type=script&lang=js"
export * from "./StatementsPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports